class TC_LanguageSwitcher {
    constructor() {
        if ($('.language-switcher').length) {
            this.initEvents();
        }
    }

    initEvents() {
        let button =  $('.language-switcher-current');
        let dropdown = $('.language-switcher-dropdown');

        button.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            dropdown.toggleClass('is-active');

            if ($('.header-user-avatar-dropdown.is-active').length) {
                $('.header-user-avatar-dropdown').removeClass('is-active');
            }
        });

        dropdown.on('click', (e) => {
            e.stopPropagation();
        });

        $(document.body).on('click', function() {
            if (dropdown.hasClass('is-active')) {
                dropdown.removeClass('is-active');
            }

            if ($('.header-user-avatar-dropdown.is-active').length) {
                $('.header-user-avatar-dropdown').removeClass('is-active');
            }
        });
    }
}
